export default {
  data() {
    return {
      errorMessage: null,
      errors: {},
      loading: false,
    };
  },

  computed: {
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },

    hasErrorMessageOnly() {
      return !this.hasErrors && this.errorMessage !== null;
    },
  },

  methods: {
    async withValidationHandling(callback, loadingProperty = 'loading', ...args) {
      this.errorMessage = null;
      this.errors = {};
      this[loadingProperty] = true;
      try {
        return await callback.call(this, ...args);
      } catch (e) {
        if (e.name !== 'ApiError') {
          throw e;
        }

        this.errorMessage = e.message;
        this.errors = e.errors;
      } finally {
        this[loadingProperty] = false;
      }

      return null;
    },
    async withLoading(callback, loadingProperty = 'loading', ...args) {
      this[loadingProperty] = true;

      try {
        await callback.call(this, ...args);
      } finally {
        this[loadingProperty] = false;
      }
    },
    async withApiErrorHandling(callback, onApiErrorCallback, loadingProperty = 'loading') {
      this[loadingProperty] = true;

      try {
        await callback.call(this);
      } catch (e) {
        if (e.name !== 'ApiError') {
          throw e;
        }

        await onApiErrorCallback.call(this, e);
      } finally {
        this[loadingProperty] = false;
      }
    },
    clearError(key) {
      this.errors[key] = null;
    },
  },
};
